import { render, staticRenderFns } from "./DocumentCareplanListing.vue?vue&type=template&id=2ac9da96&scoped=true"
import script from "./DocumentCareplanListing.vue?vue&type=script&lang=js"
export * from "./DocumentCareplanListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac9da96",
  null
  
)

export default component.exports